module.exports = __webpack_public_path__ + "static/media/viewer-dark.debea9a6.svg";